"use strict";
/**
 * 字符串拼接
 *
 * ### Example
 * ```
 * const str1 = joint('<li></li>', 3);
 * const str2 = joint(item => `<li>${item}</li>`, ['a', 'b', 'c']);
 * const str3 = joint(index => `<li>${index}</li>`, 3);
 *
 * console.log(str1); // <li></li><li></li><li></li>
 * console.log(str2); // <li>a</li><li>b</li><li>c</li>
 * console.log(str3); // <li>0</li><li>1</li><li>2</div>
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
function joint(template, time) {
    if (typeof time === 'number') {
        var arr = [];
        for (var i = 0; i < time; i++) {
            arr.push(i);
        }
        time = arr;
    }
    if (typeof template === 'string') {
        var str_1 = template;
        template = function () { return str_1; };
    }
    return time.map(template).join('');
}
exports.joint = joint;
